import { Box } from '@theme-ui/components'
import React from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

type ReactQuillProps = ReactQuill['props']
interface RichTextEditorProps extends ReactQuillProps {
  id?: string
  readOnly?: boolean
}

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
  ],
}

export default function RichTextEditor(props: RichTextEditorProps) {
  if (props.readOnly) {
    return (
      <Box
        sx={{ border: '1px solid', borderColor: 'primary', p: 3 }}
        dangerouslySetInnerHTML={{ __html: props.value as string }}
      />
    )
  }
  return <ReactQuill theme="snow" {...props} modules={modules} />
}
